import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {onMounted, ref, Ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  name: 'ScrollableElement',
  props: {
  isHorizontalScroll: Boolean
},
  setup(__props, { expose }) {

const props = __props




const scrollable: Ref<HTMLElement|undefined> = ref<HTMLElement>();

const scrollHorizontally = (e: WheelEvent) =>
{
  if (props.isHorizontalScroll)
  {
    e.preventDefault();
    e.stopPropagation();

    if (scrollable.value)
    {
      const race = 45; // How many pixels to scroll

      if (e.deltaY > 0) // Scroll right
        scrollable.value.scrollLeft += race;
      else // Scroll left
        scrollable.value.scrollLeft -= race;
    }
  }
}


onMounted(() =>
{
  if (scrollable.value)
  {
    scrollable.value.addEventListener("wheel", scrollHorizontally);
  }
})

// ------------------------------
//  Ref exposition
// ------------------------------

expose({
  scrollable
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass('scrollable ' + (__props.isHorizontalScroll ? 'horizontal' : '')),
    ref_key: "scrollable",
    ref: scrollable
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})